export default __webpack_public_path__ + "static/media/sp-sb-boy.58cb570f.webp";